export enum DeflistNode {
    List = 'dl',
    Term = 'dt',
    Desc = 'dd',
}
